import { render, staticRenderFns } from "./contactRegistration.vue?vue&type=template&id=44c77f44&scoped=true&"
import script from "./contactRegistration.vue?vue&type=script&lang=js&"
export * from "./contactRegistration.vue?vue&type=script&lang=js&"
import style0 from "./contactRegistration.vue?vue&type=style&index=0&id=44c77f44&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.10.0_babel-co_0dbbf42f62185882c0604707ed980ddd/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44c77f44",
  null
  
)

export default component.exports